import { ToolbarService } from 'sharebase-app/services/appToolBarService';
import { TrackingService } from 'sharebase/services/trackingService';
import { ProgressService } from 'phoenix/services';

require('./contentSearchResults.styles');
const template = require('./contentSearchResults.template');

type Scope = ng.IScope & { vm:ContentSearchResultsController };
/**
 * @ngdoc directive
 * @name sharebase-app.directive:sbaContentSearchResults
 * @module sharebase-app
 * @restrict E
 * @description
 *
 * `sbaContentSearchResults` displays content search results
 *
 * @usage
 *
 * <sba-content-search-results search-phrase="my phrase" item-index="0" /> 
 * 
 * @element input
 * @param {string=} searchPhrase The search text to display results for
 * 
 * @element input
 * @param {integer=} itemIndex The index of the folder item to be displayed at the top
 */
export function ContentSearchResultsDirective():ng.IDirective {
	return {
		restrict: 'E',
		controller: ContentSearchResultsController,
		controllerAs: 'vm',
		template,
		bindToController: true,
		scope: {
			searchPhrase: '@',
			itemIndex: '@'
		},
		link: function (scope:Scope, element, attrs) {
			scope.vm.pxProgressService.target = element[0];
			
			scope.$watch('vm.itemIndex', function(newVal, oldVal){
				if(!newVal){return;}
				element.attr('item-index', scope.vm.itemIndex);
			});
		}
	};
}

export class ContentSearchResultsController {
	public static $inject = [
		'$q',
		'$timeout',
		'$state',
		'$filter',
		'sbTrackingService',
		'sbaSearchDataStore',
		'sbaToolbarService',
		'pxProgressService',
		'gettextCatalog'
	];

	constructor(
		private $q:ng.IQService, 
		private $timeout:ng.ITimeoutService, 
		private $state, 
		private $filter:ng.IFilterService, 
		private sbTrackingService:TrackingService, 
		private sbaSearchDataStore, 
		private sbaToolbarService:ToolbarService, 
		public pxProgressService:ProgressService, 
		private gettextCatalog:ng.gettext.gettextCatalog		
	){
		this.loading = true;
		this.sbaToolbarService.title = this.gettextCatalog.getString('search results');
		this.noMatchMsg = this.gettextCatalog.getString('We were unable to find items matching: {{phrase}}', {
			phrase: this.searchPhrase
		});
		this.setFolderData();
	}

	public loading:boolean;
	public itemIndex;
	public searchPhrase;
	public noMatchMsg;

	public itemClicked(item) {
		if (item.FolderId) {
			this.$state.go('content.myFiles.folder', { 'folderID': item.FolderId });
			return;
		}

		this.$state.go('content.myFiles.document', { 'docID': item.DocumentId });
		
		this.sbTrackingService.trackClick('Basic search result found', 'full search results');
	}

	public setFolderData() {
		let p = this.$q.resolve();
		if (this.searchPhrase) {
			this.pxProgressService.visible = true;
			this.sbaToolbarService.title = this.gettextCatalog.getString('Search results for "{{phrase}}"', { 
				phrase: this.searchPhrase 
			});
			p = this.sbaSearchDataStore.load(this.searchPhrase);
		}

		p.then(() => this.setInitialIndex());
	}

	public setInitialIndex() {
		//if the item index is set then let make sure the virtual repeat
		if (this.sbaToolbarService.viewType.name !== 'card' || this.itemIndex === '0' || !angular.isDefined(this.itemIndex)) {
			this.doneLoading();
			return;
		}
		if (this.itemIndex !== undefined && this.itemIndex !== '0') {
			var index = this.itemIndex;
			this.itemIndex = 0;
			this.$timeout(function () {
				this.itemIndex = parseInt(index);
				this.doneLoading();
			}, 500);
		}
	}

	public doneLoading() {
		this.pxProgressService.visible = false;
		this.loading = false;
	}
}



// WEBPACK FOOTER //
// ./src/sharebase-app/components/contentSearchResults/contentSearchResults.ts